<template>
  <section
    v-editable="blok"
    class="hero-payers pt-96"
    :style="[paddingBottom, backgroundColor]"
  >
    <div :class="[
      'hero-payers__wrapper container',
      {
        'hero-payers__wrapper--wide-content': blok.wide_content
      }
      ]">
      <div class="hero-payers__content">
        <StoryblokComponent
          v-for="childBlok in blok.heading_content"
          :key="childBlok._uid"
          :blok="childBlok"
        />
      </div>
      <div class="hero-payers__image-wrapper">
        <BaseNuxtImage
          class="hero-payers__image-desktop"
          :src="(blok.image_desktop && blok.image_desktop.filename) || ''"
          :alt="(blok.image_desktop && blok.image_desktop.alt) || ''"
        />
        <BaseNuxtImage
          class="hero-payers__image-mobile"
          :src="(blok.image_mobile && blok.image_mobile.filename) || ''"
          :alt="(blok.image_mobile && blok.image_mobile.alt) || ''"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { SbHeroRegional } from '@/types'
interface Props {
  blok: SbHeroRegional
}
const props = defineProps<Props>()

const paddingBottom = computed(() => {
  return {
    '--padding-bottom-desktop': `${props.blok.padding_bottom}px`,
  }
})
const backgroundColor = computed(() => {
  return {
    backgroundColor: props.blok.bg_color.value,
  }
})
</script>

<style lang="scss" scoped>
.hero-payers {
  --padding-bottom-desktop: 128px;
  overflow: hidden;

  @media (min-width: $breakpoint-lg) {
    padding-bottom: var(--padding-bottom-desktop);
  }

  &__wrapper {
    @media (min-width: $breakpoint-lg) {
      display: grid;
      grid-template-columns: 573px auto;
      column-gap: 60px;
    }
    
    &--wide-content {
      @media (min-width: $breakpoint-lg) {
      grid-template-columns: 720px auto;
      column-gap: 0;

    }

    }
  }
  &__image-desktop {
    display: none;

    @media (min-width: $breakpoint-md) {
      display: block;
      max-width: 550px;
      height: auto;
    }
  }

  &__image-wrapper {
    min-height: 400px;
    margin-top: 80px;
    display: flex;
    justify-content: center;

    @media (min-width: $breakpoint-lg) {
      margin-top: 20px;
    }
  }
  &__image-mobile {
    right: 0;
    position: absolute;
    height: auto;

    @media (min-width: $breakpoint-md) {
      display: none;
    }
  }
}
html:lang(de) {
  .hero-payers__image-wrapper {
    min-height: 470px;
  }
}
</style>
